import React from 'react';
import classNames from 'classnames';

import styles from './MenuItem.scss';

export type MenuItemIntent = 'base' | 'danger' | 'primary' | 'cancel' | 'action';

export type MenuItemProps = {
  children: string | React.ReactElement;
  onClick?: () => void;
  selected?: boolean;
  intent?: MenuItemIntent;
};

function MenuItem({ children, intent = 'base', selected, onClick }: MenuItemProps) {
  return (
    <div className={classNames(styles.item, styles[intent], { [styles.selected]: selected })} onClick={onClick}>
      {children}
    </div>
  );
}

export default React.memo(MenuItem);
